/**
 * Column in site map with links of months that clicks out
 * to page with articles for that year & month.
 * This is used for both articles & advice site map as well as buying guides.
 */
import React from 'react';
import { SiteMapMonthListing } from './SiteMapMonthListing';
export var SiteMapYearListing = function SiteMapYearListing(_ref) {
  var data = _ref.data;
  var years = Object.keys(data);
  return /*#__PURE__*/React.createElement(React.Fragment, null, years.map(function (year) {
    return /*#__PURE__*/React.createElement(SiteMapMonthListing, {
      year: year,
      months: data[year],
      key: year
    });
  }));
};